import React, { Component } from 'react';
import { userService } from "../../../_services";
import close_btn from '../../../images/close_btn.svg';
import search_icon from "../../../images/search_icon.png";
import receipticon from "../../../images/nlsreceipt.svg";
import Pagination from '../Group_no/pagination';
import NLSReportRow from './NLSReportRow';
import moment from 'moment';
import DateRangePicker from 'react-bootstrap-daterangepicker';

class NLSRxOrderReport extends Component {
    constructor(props) {
        var startdate = new Date('01-30-2025');
        var enddate = new Date();
        super(props);
        this.state = {
            shortname: '',
            fullName: '',
            startDate: new moment(startdate).format("MM/DD/YYYY"),
            endDate: new moment(enddate).format("MM/DD/YYYY"),
            nlsOrdersList: [],
            nlsOrdersListTemp: [],
            filteredNlsOrdersList: [],
            searchText: '',
            orderUsername: '',
            order_popup: false,
            order_details: [],
            popupLoader: false,
            orderStatus: null,
            orderId: null,
            loader: false,
            pageOfItems: [],
        }
        this.handleSearchFilter = this.handleSearchFilter.bind(this);
        this.handleCalendar = this.handleCalendar.bind(this);
        this.onChangePage = this.onChangePage.bind(this);
    }
    componentDidMount() {
        let usernamedata = window.atob(localStorage.getItem('hacker_user_detail'));
        this.setState({ shortname: usernamedata.split(':')[0], fullName: usernamedata.split(':')[1] });
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.GetNLSPaymentsAdmin(Usermeta_Data.split(':')[0], this.state.startDate, this.state.endDate);
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevState.order_popup !== this.state.order_popup) {
            if (this.state.order_popup) {
                document.body.style.overflow = 'hidden';
            } else {
                document.body.style.overflow = '';
            }
        }
    }
    componentWillUnmount() {
        document.body.style.overflow = '';
    }
    GetNLSPaymentsAdmin(UserId, startDate, endDate) {
        this.setState({ loader: true })
        try {
            let startdate = new moment(new Date(startDate)).format("YYYY-MM-DD")
            let enddate = new moment(new Date(endDate)).format("YYYY-MM-DD")
            userService.FetchNLSPaymentsAdmin(UserId, startdate, enddate)
                .then(apidata => {
                    this.setState({ loader: false })
                    if (apidata.length > 0) {
                        this.setState({ nlsOrdersList: apidata, nlsOrdersListTemp: apidata })
                    }
                });
        }
        catch (err) {
            console.log(err)
            this.setState({ loader: false })
        }
    }
    handleCalendar(e, picker) {
        let changedStartDate = new moment(picker.startDate).format("MM/DD/YYYY");
        let changedEndDate = new moment(picker.endDate).format("MM/DD/YYYY");
        let Usermeta_Data = window.atob(localStorage.getItem('ajs_user_id'));
        this.setState({
            searchText: '',
            startDate: changedStartDate,
            endDate: changedEndDate
        }, () => {
            this.GetNLSPaymentsAdmin(Usermeta_Data.split(':')[0], changedStartDate, changedEndDate);
        })
    }
    handleSearchFilter = (val, e) => {
        try {
            const { nlsOrdersListTemp } = this.state
            let serachText = '';
            if (e == undefined) {
                serachText = val;
            }
            else {
                serachText = e.target.value;
            }

            let duplicateNlsOrdersList = nlsOrdersListTemp.filter(function (e1) {
                return (e1.email.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.fullName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.userName.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.phone.toLowerCase().indexOf(serachText.toLowerCase()) !== -1 || e1.orderStatus.toLowerCase().indexOf(serachText.toLowerCase()) !== -1)
            });

            if (duplicateNlsOrdersList.length > 0) {
                this.setState({ nlsOrdersList: duplicateNlsOrdersList });
            } else {
                if (serachText.length === 0) {
                    this.setState({ nlsOrdersList: nlsOrdersListTemp });
                } else {
                    this.setState({ nlsOrdersList: [] });
                }
            }
        }
        catch (err) { }
    }
    toggle_order_details_popup = (e, orderId, orderUsername, orderStatus) => {
        try {
            e.stopPropagation();
            this.setState({ order_popup: !this.state.order_popup, popupLoader: true, orderId: orderId, orderUsername: orderUsername })
            if (orderId && orderId !== '-') {
                userService.FetchNLSPaymentsOrderAdmin(orderId)
                    .then(apidata => {
                        this.setState({ order_details: apidata, popupLoader: false })
                    });
            } else {
                if (orderId === '-') {
                    this.setState({ order_details: [], popupLoader: false, order_popup: true, orderStatus: JSON.parse(orderStatus) })
                } else {
                    this.setState({ order_details: [], popupLoader: false })
                }
            }
        }
        catch (err) { }
    }
    onChangePage(pageOfItems) {
        try {
            this.setState({ pageOfItems: pageOfItems });
        }
        catch (err) { }
    }
    render() {
        let { order_popup, popupLoader, loader, order_details, orderUsername, pageOfItems, nlsOrdersList, orderStatus, orderId } = this.state;
        let disabled = false;
        disabled = this.state.loader ? true : false;

        return (
            <div>
                <span className="back-button" onClick={this.props.hideNLSRxSection}>Back</span>
                <div className="monthly_comm nlsorder_header">
                    <h2>NLS Rx Marketplace Orders</h2>
                    {loader && <div className="page-loader" style={{ marginLeft: '10px', marginRight: 'auto' }}></div>}
                </div>
                <div className="header_bard_button userpage_header_bard nlsreportpage_header">
                    <div className="searchbar">
                        <img src={search_icon} alt="" />
                        <input type="text" disabled={disabled} id="SearcInput" className="form-control searchTable searchtextarea" autoComplete="off" name="searchtext" placeholder="Search" onKeyUp={this.handleSearchFilter.bind(this, '')} />
                    </div>
                    <div className="new-column gap-left nlsreport-datepicker">
                        <div className="same-on">
                            <label>&nbsp;</label>
                            <DateRangePicker popperModifiers={{ preventOverflow: { enabled: true, }, }} disabled={disabled} initialSettings={{ startDate: this.state.startDate, endDate: this.state.endDate, maxDate: moment(), minDate: new Date('01-30-2025') }} onApply={this.handleCalendar}>
                                <div>
                                    <div className="react-datepicker_input-container first-one">
                                        <input type="text" className="form-control first readonly-attr" readOnly value={this.state.startDate} />
                                    </div>
                                    <div className="react-datepicker_input-container second-one">
                                        <input type="text" className="form-control readonly-attr" readOnly value={this.state.endDate} />
                                    </div>
                                </div>
                            </DateRangePicker>
                        </div>
                    </div>
                </div>
                <div className="tab-content">
                    <div className="new-report">
                        <div className="tabular_box nls_report_table">
                            <div className="table_header user_page user_data main">
                                <div>User Name</div>
                                <div>Full Name</div>
                                <div>Email</div>
                                <div>Phone</div>
                                <div>Order Date</div>
                                <div>Order Status</div>
                            </div>
                            <div className="table_body">
                                {loader ? <div className="norecords">Records are loading..</div> : <>{pageOfItems && pageOfItems.length ? pageOfItems.map((orderrow, index) =>
                                    <NLSReportRow
                                        index={index}
                                        key={index}
                                        {...orderrow}
                                        toggle_order_details_popup={(e) => this.toggle_order_details_popup(e, orderrow.orderId, orderrow.userName, orderrow.orderStatus)}
                                    />
                                ) : <div className="norecords">No record found</div>}</>}
                            </div>
                            <Pagination items={nlsOrdersList} onChangePage={this.onChangePage} />
                        </div>
                    </div>
                </div>
                {order_popup === true ? (
                    <div className="resetgroup_box dist_popup nlsorder_popup">
                        <div className="add_url_pop">
                            <div>
                                <div className="header">
                                    <h2>{orderUsername}</h2>
                                    <div className={popupLoader ? "close loader" : "close"} onClick={this.toggle_order_details_popup.bind(this)}>
                                        <img src={close_btn} alt="" />
                                    </div>
                                </div>
                                <div className="tabular_box">
                                    {orderId && orderId !== '-' ? <div className="override_section">
                                        <div className="table_header user_page user_data">
                                            <div>Product Name</div>
                                            <div>Product Quantity</div>
                                            <div>Product Price</div>
                                            <div>Receipt</div>
                                        </div>
                                        <div>
                                            {order_details && order_details.length > 0 ?
                                                <div className="table_body direct-sec">
                                                    {
                                                        order_details.map((item, index) => {
                                                            return (
                                                                <div className="table_row user_page user_data" key={index}>
                                                                    <div>
                                                                        <div>{item.productName}</div>
                                                                        <div>{item.productQuantity}</div>
                                                                        <div>{item.productPrice}</div>
                                                                        <div>
                                                                            {item.paymentReceipt && index.toString() === '0' ? <a href={item.paymentReceipt} target="_blank" className="nls-receipt">
                                                                                <img src={receipticon} style={{ maxWidth: '20px' }} />
                                                                                <span className="hover-tooltip">View/Download Receipt</span>
                                                                            </a> : null}
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })
                                                    }
                                                </div> :
                                                <div>
                                                    {popupLoader ? <div className="no_record_found">Records are loading..</div> : <div className="no_record_found">No Record Found</div>}
                                                </div>
                                            }
                                        </div>
                                    </div> :
                                        <div>
                                            <div className="table_body direct-sec">
                                                {orderStatus && orderStatus.errors ? orderStatus.errors.map((item, index) => (
                                                    Object.entries(item).map(([key, value]) => (
                                                        <div className="table_row user_page user_data" key={`${index}-${key}`}>
                                                            <div>
                                                                <div style={{ width: '50%', maxWidth: 'none' }}>{key}</div>
                                                                <div style={{ width: '50%', maxWidth: 'none' }}>{value}</div>
                                                            </div>
                                                        </div>
                                                    ))
                                                )) : null}
                                            </div>
                                        </div>
                                    }

                                </div>
                            </div>
                        </div>
                    </div>
                ) : null}
            </div>
        )
    }
}
export default NLSRxOrderReport;